'use client';

import React from 'react';
import { ContentSliderProps } from 'components/commercetools-ui/organisms/content-slider/types';
import { TasticProps } from 'frontastic/tastics/types';
import TilesMultipleCTA from 'components/commercetools-ui/organisms/content/tiles-multiple-cta';

const TilesMultipleCTATastic = ({ data }: TasticProps<ContentSliderProps>) => {
  return <TilesMultipleCTA data={data?.data?.dataSource} />;
};

export default TilesMultipleCTATastic;